import api, { ApiResponse } from "../api";
import { PaginatedTransactionMessagesResponse, TransactionMessageDefinitionsResponse, TransactionMessageDump, TransactionMessageIssueResponse, TransactionMessageReprocessRequest, TransactionMessageReprocessResponse, TransactionMessagesRequest } from "./models";

class TransactionMonitorService {
  private source: any;
  private static instance: TransactionMonitorService;

  private constructor() { }

  static getInstance(): TransactionMonitorService {
    if (!TransactionMonitorService.instance) {
      TransactionMonitorService.instance = new TransactionMonitorService();
    }
    return TransactionMonitorService.instance;
  }

  public getDifinitions = async (): Promise<ApiResponse<TransactionMessageDefinitionsResponse>> => {
    return await api.get(
      "/message/definitions/all",
      {}
    );
  };

  public getTransactionMessages = async (
    requestData: TransactionMessagesRequest
  ): Promise<ApiResponse<PaginatedTransactionMessagesResponse>> => {
    return await api.get(
      "/message",
      { params: requestData }
    );
  };

  public getIssueDetails = async (messageId: string): Promise<ApiResponse<TransactionMessageIssueResponse>> => {
    return await api.get(
      `/message/${messageId}/issue`,
      {}
    );
  };

  public getMessageDump = async (messageId: string): Promise<ApiResponse<TransactionMessageDump>> => {
    return await api.get(
      `/message/${messageId}/dump`,
      {}
    );
  };

  public submitMessageForReprocessing = async (requestData: TransactionMessageReprocessRequest): Promise<ApiResponse<TransactionMessageReprocessResponse>> => {
    return await api.post(
      "/message-reprocessing",
      requestData,
      {}
    );
  };
}
export default TransactionMonitorService;